<template>
    <div class="daigou-pay" v-show="show">
        <div class="pay-mask" @click="close"></div>
        <div class="pay-box">
            <div class="pay-header">
                <span>订单支付</span>
                <span class="close" @click="close">×</span>
            </div>
            <div class="pay-body">
                <div class="money-row">
                    应付金额：<span class="money">￥{{ order.total_money | price }}</span>
                </div>
                <div class="method-list">
                    <div class="method-item" :class="{ active: pay_type == 'wechat' }" @click="changePayType('wechat')">微信支付</div>
                    <div class="method-item" :class="{ active: pay_type == 'alipay' }" @click="changePayType('alipay')">支付宝</div>
                    <div class="method-item" :class="{ active: pay_type == 'balance' }" @click="changePayType('balance')">余额支付</div>
                </div>

                <div class="pay-area">
                    <template v-if="pay_type == 'balance'">
                        <div class="balance-btn" @click="onPay">确认支付</div>
                    </template>
                    <template v-else>
                        <div v-if="!pay_url && !alipay_form" class="get-code-btn" @click="onPay">获取支付二维码</div>
                        <div v-else-if="pay_type == 'wechat'" class="qrcode-box">
                            <canvas ref="qrcode" width="220" height="220"></canvas>
                            <p>请使用微信扫一扫支付</p>
                        </div>
                        <div v-else class="qrcode-box">
                            <iframe v-if="alipay_form" :srcdoc="alipay_form" frameborder="0" width="220" height="220"></iframe>
                            <p>请使用支付宝扫一扫支付</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { PayDesignDaigouOrder } from "@/api/daigou";
import { CheckPayStatus } from "@/api/index";
let QRCode = require("qrcode");
export default {
    name: "DaigouPay",
    filters: {
        price(v) {
            return Number(v || 0).toFixed(2);
        }
    },
    data() {
        return {
            show: false,
            order: {},
            pay_type: "wechat",
            pay_url: "",
            alipay_form: "",
            pay_id: "",
            timer: null,
            pollCount: 0,
        };
    },
    methods: {
        open(order) {
            this.order = order || {};
            this.pay_type = "wechat";
            this.pay_url = "";
            this.alipay_form = "";
            this.pay_id = "";
            this.pollCount = 0;
            this.show = true;
        },
        close() {
            this.show = false;
            this.stopPolling();
        },
        stopPolling() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        // 切换支付方式时必须清空已生成的支付凭证：否则微信/支付宝互切时
        // 会出现「获取支付二维码」按钮被隐藏（空白二维码/空白 iframe）而无法重新下单
        changePayType(type) {
            if (this.pay_type === type) return;
            this.pay_type = type;
            this.pay_url = "";
            this.alipay_form = "";
            this.pay_id = "";
            this.pollCount = 0;
            this.stopPolling();
        },
        async onPay() {
            if (this.pay_type == "balance") {
                this.$Spin.show();
                try {
                    const { code, msg } = await PayDesignDaigouOrder({ uuid: this.order.uuid, pay_type: "balance" });
                    if (code > 0) {
                        this.$layer.msg(msg);
                        return;
                    }
                    this.$layer.msg("支付成功~");
                    this.close();
                    this.$emit("paid");
                } catch (e) {
                    this.$layer.msg(e.msg || "支付失败");
                } finally {
                    this.$Spin.hide();
                }
                return;
            }
            // $Spin 遮罩同时避免重复点击造成重复下单 / 重复生成二维码
            this.$Spin.show();
            try {
                const { code, msg, data } = await PayDesignDaigouOrder({ uuid: this.order.uuid, pay_type: this.pay_type });
                if (code > 0) {
                    this.$layer.msg(msg);
                    return;
                }
                if (!data) {
                    this.$layer.msg("获取支付信息失败，请重试");
                    return;
                }
                if (this.pay_type == "wechat") {
                    this.pay_url = data.url;
                    this.pay_id = data.pay_id;
                    this.$nextTick(() => {
                        if (this.$refs.qrcode) {
                            QRCode.toCanvas(this.$refs.qrcode, this.pay_url, { width: 220 }, () => {});
                        }
                    });
                    this.startPolling();
                } else if (this.pay_type == "alipay") {
                    this.alipay_form = data.content;
                    this.pay_id = data.pay_id;
                    this.startPolling();
                }
            } catch (e) {
                this.$layer.msg(e.msg || "获取支付二维码失败");
            } finally {
                this.$Spin.hide();
            }
        },
        startPolling() {
            this.stopPolling();
            this.pollCount = 0;
            this.timer = setInterval(async () => {
                if (!this.pay_id) return;
                // 最长轮询 5 分钟（100 次 × 3s），避免无限轮询
                this.pollCount += 1;
                if (this.pollCount > 100) {
                    this.stopPolling();
                    this.$layer.msg("支付结果确认超时，请稍后在「我的代购订单」查看支付状态");
                    return;
                }
                try {
                    const res = await CheckPayStatus({ pay_id: this.pay_id });
                    if (res.data && res.data.status === 1) {
                        this.stopPolling();
                        this.$layer.msg("支付成功~");
                        this.close();
                        this.$emit("paid");
                    }
                } catch (e) {
                    // ignore
                }
            }, 3000);
        },
    },
    beforeDestroy() {
        this.stopPolling();
    },
};
</script>
<style lang="scss" scoped>
.daigou-pay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 200;
    .pay-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }
    .pay-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 480px;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        .pay-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 20px;
            font-size: 16px;
            font-weight: bold;
            border-bottom: 1px solid #eee;
            .close {
                cursor: pointer;
                font-size: 20px;
                color: #999;
            }
        }
        .pay-body {
            padding: 24px 20px;
            .money-row {
                font-size: 15px;
                color: #333;
                margin-bottom: 20px;
                .money {
                    color: #ff5967;
                    font-size: 22px;
                    font-weight: bold;
                }
            }
            .method-list {
                display: flex;
                gap: 12px;
                margin-bottom: 20px;
                .method-item {
                    flex: 1;
                    text-align: center;
                    padding: 10px 0;
                    border: 1px solid #e3e3e3;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 14px;
                    color: #333;
                    &.active {
                        border-color: #ff5967;
                        color: #ff5967;
                        background: #fff0f1;
                    }
                }
            }
            .pay-area {
                display: flex;
                justify-content: center;
                min-height: 260px;
                align-items: center;
                flex-direction: column;
                .balance-btn {
                    background: #ff5967;
                    color: #fff;
                    padding: 12px 48px;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 15px;
                }
                .get-code-btn {
                    background: #ff5967;
                    color: #fff;
                    padding: 12px 40px;
                    border-radius: 6px;
                    cursor: pointer;
                    font-size: 15px;
                }
                .qrcode-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 12px;
                    p {
                        color: #666;
                        font-size: 13px;
                    }
                }
            }
        }
    }
}
</style>
